module.exports = __webpack_public_path__ + "static/media/logo.0d512ff8.svg";